import {Filesystem} from '@capacitor/filesystem';

export function checkFileSystemPermissions(): Promise<void> {
    return new Promise(async (resolve, reject) => {
        const status = await Filesystem.checkPermissions();
        const state = status.publicStorage;

        if (state === 'granted') {
            resolve();
            return;
        } else {
            const requestPermissionStatus = await Filesystem.requestPermissions();
            if (requestPermissionStatus.publicStorage === 'granted') {
                resolve();
                return;
            }
        }
        reject();
    });
}
